import classes from "./Footer.module.css";
const Footer = (props) => {
  return (
    <footer className={classes.Footer}>
    </footer>
  );
};

export default Footer;
